import { useEffect, useMemo, useRef } from 'react';

 const delay = (getFn: () => () => void, ms = 1000) => {
    let timer: string | number | NodeJS.Timeout | null;

    const cb = () => {
        timer = setTimeout(() => {
            getFn()();
        }, ms);
    };

    return {
        callback: cb,
        clear: () => {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        }
    };
};

// please use only functions wrapped in useCallback
export const useDelayedCallback = (cb: () => void, ms = 1000) => {
    const cbRef = useRef(cb);

    useEffect(() => {
        cbRef.current = cb;
    });

    const { callback, clear } = useMemo(
        () => delay(() => cbRef.current, ms),
        [ms]
    );

    useEffect(() => {
        return () => {
            clear();
        };
    }, [clear]);

    return callback;
};
